import { initializeApollo } from '@gql/client'
import { PaginaDocument } from '@gql/graphql'
import { search } from '@utils/elasticsearch'
import { NextWrapper } from 'data-fetching-wrapper'
import * as Sentry from '@sentry/nextjs'
import { SearchResultTemplate } from '@components/templates'

const Ricerca = ({ pagina, query, risultati }) => {
  return <SearchResultTemplate pagina={pagina} query={query} risultati={risultati} />
}

export const getServerSideProps = NextWrapper.getServerSideProps(
  async ({ res, query, locale, preview, previewData }) => {
    const client = initializeApollo(locale)

    const headers = preview && previewData?.headers ? { cookie: previewData.headers } : {}

    const {
      data: { pagina },
    } = await client.query({
      query: PaginaDocument,
      variables: { chiave: 'search', preview },
      context: {
        headers,
      },
    })

    if (!pagina) {
      return {
        notFound: true,
      }
    }

    const q = (typeof query?.q == 'string' ? query?.q : query?.q?.[0]) || ''

    let risultati = []
    if (q) {
      try {
        const response = await search(locale, q)
        risultati = response.results || []
      } catch (error) {
        Sentry.captureException(error)
        console.log(error)
      }
    }

    res.setHeader('Cache-Control', 'public, s-maxage=60, stale-while-revalidate')

    return {
      props: { pagina, query: q, risultati, key: q },
    }
  }
)

export default Ricerca
